import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import getPageUrl from "./elements/getPageUrl/getPageUrl";
import BuildGrid from "./elements/BuildGrid/BuildGrid";
import { Api } from "../../../services/Api";
import { useDispatch } from "react-redux";
import { setIsWaiting } from "../../../redux/actions/appActions";
import WaitingBottomBar from "./elements/WaitingBottomBar/WaitingBottomBar";
import { IFilters } from "../Search/elements/FiltersMenu/FiltersMenu";

interface IGrid {
  endpoint: string;
  filters?: IFilters;
  itemType?: string;
}

export interface IRecipe {
  id: number;
  description: string;
  imageUrl: string;
  ingredients: string;
  isPublic: boolean;
  languageId: string;
  languageName: string;
  name: string;
  preparationTime: number;
  publicationDateTime: string;
  sourceUrl: string;
  userId: number;
  isFromExplore: boolean;
}

const Grid: React.FC<IGrid> = (props) => {
  const pageSize = 54;
  const [areMoreRecipesAvailable, setAreMoreRecipesAvailable] = useState(true);
  const [items, setItems] = useState<IRecipe[]>([]);
  const [page, setPage] = useState(0);
  const dispatch = useDispatch();

  const loadRecipes = async (isFirstLoad: boolean) => {
    const response = await Api.get(getPageUrl(props.endpoint, pageSize, page, props.filters));
    const data = response.data;
    if (data.length < pageSize) {
      setAreMoreRecipesAvailable(false);
    }
    if (isFirstLoad) {
      setItems([...data]);
    } else {
      setItems([...items, ...data]);
    }
    dispatch(setIsWaiting(false));
  };

  useEffect(() => {
    loadRecipes(false);
  }, [page]);

  useEffect(() => {
    setItems([]);
    setPage(0);
    setAreMoreRecipesAvailable(true);
    loadRecipes(true);
  }, [props.endpoint, props.filters]);

  useEffect(() => {
    const handleScroll = () => {
      if (
        areMoreRecipesAvailable &&
        window.innerHeight + document.documentElement.scrollTop === document.documentElement.offsetHeight
      ) {
        setPage(page + 1);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [page]);

  return (
    <div>
      <BuildGrid items={items} itemType={props.itemType} />
      {areMoreRecipesAvailable && <WaitingBottomBar />}
    </div>
  );
};

export { Grid, BuildGrid };
